import { SendWindowsSection } from '../components/SendWindowsSection';

/**
 * Eigene Seite statt Teil von "Mein Konto" -- Abschickzeiten sind eine
 * eigenständige Planungshilfe, keine Kontoeinstellung im engeren Sinn.
 */
export function SendWindowsPage() {
  return (
    <div className="stack-narrow">
      <SendWindowsSection />
    </div>
  );
}
